// extracted by mini-css-extract-plugin
export var select = "_p5-0";